import { GridSpg } from "@duosoftbg/nacid-components";

const ScrollableGridContainer = ({ spacing = 2, children }) => {
  return (
    <GridSpg style={{ marginTop: "0px", overflowY: "auto", maxHeight: "250px" }} container spacing={spacing}>
      {children}
    </GridSpg>
  );
};

export default ScrollableGridContainer;
